// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2MsOG","input":"styles_input__O1Cwy","checkboxIcon":"styles_checkboxIcon__lre65"};